import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import { Provider } from 'react-redux';
import store from './store';
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

import './index.css';

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	 document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js